import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { BehaviorSubject,  Subscription } from 'rxjs';
import {  map } from 'rxjs/operators';
import { MasterPerfilAcessoService } from "./services/master-perfil-acesso.service";
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-master-perfil-acesso',
  templateUrl: './master-perfil-acesso.component.html',
  styleUrls: ['./master-perfil-acesso.component.scss']
})

export class MasterPerfilAcessoComponent implements OnInit {
  profiles: any;
  filterAutoComplete: any;
  userFilter: any;
  clientStatus = true;
  dataAccordion: object;
  name: any;
  sortedData: any;
  permissionDados: Permissions[];
  isAsc = true;
  count: any;
  model: any;
  hideme:any = {};
  indexChoice:number = 0; //At first equal=-1, so all episodes are showed
  perfilSelected: string;
  id: any;
  panelOpenState;

  @Output() filterProfile: EventEmitter<any> = new EventEmitter<any>();
  @Output() formPerfil: EventEmitter<any> = new EventEmitter<any>();
  
  @Input() form;
  @Input() clientIds: BehaviorSubject<string>;
  
  clientIdsSubscrion: Subscription;
  

  constructor(
    private _MasterPerfilAcessoService: MasterPerfilAcessoService
  ) { }

  ngOnDestroy(): void {
    this.clientIdsSubscrion.unsubscribe()
  }

  ngOnInit() {    

    this.clientIdsSubscrion = this.clientIds.pipe(     
      map((lista: any) => {
        const listaJoin = lista.map(item => "id" + ":" + "'" + item.name.id + "'");
        return listaJoin;
      })
    )
    .subscribe(async (valor) => {
      this.model = await this._MasterPerfilAcessoService.getIds(valor);
      let radioGroup = this.form.get('typeProfileRadio');
      console.log('Model', this.model);
      //refatorar depois
      this.model[0].id = "Fake";
      radioGroup.setValue(this.model[0].id);


      if(this.model == ''){
        console.log("Não existem perfis cadastrados neste cliente");
      }
    
    }
    , error => {
      if(error.status == 404){
        console.log("Erro 404", error);
      }
      if(error.status == 403){
        console.log("Erro 403", error);
      }
    })

  }

  

  onClick(index, id) {
    Object.keys(this.hideme).forEach(h => {
      console.log(h);
      this.hideme[h] = false;
    });
    console.log(this.hideme);

    this.hideme[index] = true
  }
  updateRadioProfile(i) {
    this.indexChoice= i;
    this.formPerfil = this.form;
    console.log('updateRadioProfile', JSON.stringify({...this.form.value}));
  }

  async filterUsers(event: Event) {
    this.userFilter = (event.target as HTMLInputElement).value;

    if (this.userFilter.length > 0 && this.userFilter.length % 2 == 0) {
      const result = await this._MasterPerfilAcessoService.getProfileSearch(this.userFilter)
      this.proxyAutoComplete(this.userFilter);

    } else if (this.userFilter.length == 0) {
      this.filterAutoComplete = []
    }

  }

  proxyAutoComplete(term = null) {
    if (!term) return;
    const complete = this.profiles.map((client) => {
      return client.permissionGroupProfiles.filter((prof) => {
        return prof.profile != undefined
      }).map((pro) => {
        return pro.profile
      })
    })
    this.filterAutoComplete = [].concat(...complete).filter((ele) => ele.toLowerCase().includes(term.toLowerCase()))
  }

  teste(index) {
    console.log(index);
  }

}
